export const TRAFFIC_CHANNEL = {
  SPECIFIC_AUDIENCE: 'SPA',
};
